module.exports = __webpack_public_path__ + "img/MIRAEASSET.1659364c.svg";